/**
 * 区分 paymentStatus（transactions.payment_status）
 * 出典：要件書 2.3
 */
export const PAYMENT_STATUS_VALUES = ['unbilled', 'invoiced', 'paid'] as const;

export type PaymentStatus = (typeof PAYMENT_STATUS_VALUES)[number];

export const PAYMENT_STATUS_LABELS: Readonly<Record<PaymentStatus, string>> = {
  unbilled: '未請求',
  invoiced: '請求済',
  paid: '入金済',
};
